<template>
  <div data-testid="benefit-title" class="flex items-center gap-2 py-2">
    <strapi-image
      fluid
      :image="benefit.icon"
      :force-width="18"
      :force-height="18"
      :alt="benefit.title"
      class="flex-shrink-0"
    />
    <strong class="whitespace-nowrap">{{ benefit.title }}</strong>
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import type { GetProductQuery } from '~/apollo/types/types';

const props = withDefaults(
  defineProps<{
    benefit: GetProductQuery['product_top_bar'][number];
  }>(),
  {},
);
</script>
